module.exports = __webpack_public_path__ + "img/t2-purple.fd1ecbe2.png";